import {
  RESEND_INVITATION,
  RESEND_INVITATION_FAILURE,
  RESEND_INVITATION_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const resendInvitationReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESEND_INVITATION:
      return { ...state, loading: true };
    case RESEND_INVITATION_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case RESEND_INVITATION_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default resendInvitationReducer;
